import {ConnectionType, DataType} from '@flowmaps-com/flowmaps-typescriptmodels';

export function connectionConsumptionType(type: ConnectionType | string): DataType {
    switch (type) {
        case ConnectionType.Electricity: return DataType.electricityConsumption;
        case ConnectionType.Gas: return DataType.gasConsumption;
        case ConnectionType.Heat: return DataType.heatConsumption;
        case ConnectionType.Cooling: return DataType.coolingConsumption;
        case ConnectionType.Water: return DataType.waterConsumption;
        case ConnectionType.ChargePoint: return DataType.chargePointConsumption;
        default: throw new Error('Unsupported connection type');
    }
}
